import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bedc3e60&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedc3e60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bedc3e60')) {
      api.createRecord('bedc3e60', component.options)
    } else {
      api.reload('bedc3e60', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bedc3e60&scoped=true&", function () {
      api.rerender('bedc3e60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting/bonusConfig/index.vue"
export default component.exports